import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from "@angular/common/http";
import { AuthRoutingModule } from "./auth-routing.module";
import { LoginComponent } from "./components/login/login.component";
import { RegistrationComponent } from "./components/registration/registration.component";
import { ForgotPasswordComponent } from "./components/forgot-password/forgot-password.component";
import { LogoutComponent } from "./components/logout/logout.component";
import { AuthComponent } from "./auth.component";
import { TranslationModule } from "../../i18n/translation.module";
import { SharedModule } from "src/shared/shared.module";
import { FormComponent } from "../profile/account/components/user-profile/components/address-form/form/form.component";
import { BrandLogoComponent } from "src/shared/brand-logo/brand-logo.component";

@NgModule({
  declarations: [
    LoginComponent,
    RegistrationComponent,
    ForgotPasswordComponent,
    LogoutComponent,
    AuthComponent,
  ],
  imports: [
    BrandLogoComponent,
    CommonModule,
    TranslationModule,
    AuthRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    FormComponent
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  exports: [LoginComponent, RegistrationComponent, ForgotPasswordComponent],
})
export class AuthModule { }
